export const MY_CHECKUPS_GET = 'MY_CHECKUPS_GET';
export const MY_CHECKUPS_GET_SUCCESS = 'MY_CHECKUPS_GET_SUCCESS';
export const MY_CHECKUPS_GET_ERROR = 'MY_CHECKUPS_GET_ERROR';

export const SELECTED_CHECKUP_TABLE = 'SELECTED_CHECKUP_TABLE';

export const CHECKUPS_HEALTH_RECORD_REQUEST = 'CHECKUPS_HEALTH_RECORD_REQUEST';
export const CHECKUPS_HEALTH_RECORD_REQUEST_SUCCESS = 'CHECKUPS_HEALTH_RECORD_REQUEST_SUCCESS';
export const CHECKUPS_HEALTH_RECORD_REQUEST_ERROR = 'CHECKUPS_HEALTH_RECORD_REQUEST_ERROR';

export const CHECKUPS_RECORD_IMAGE_OPEN = 'CHECKUPS_RECORD_IMAGE_OPEN';
export const CHECKUPS_RECORD_IMAGE_OPEN_SUCCESS = 'CHECKUPS_RECORD_IMAGE_OPEN_SUCCESS';
export const CHECKUPS_RECORD_IMAGE_OPEN_ERROR = 'CHECKUPS_RECORD_IMAGE_OPEN_ERROR';

export const ALL_PACKAGES_GET = 'ALL_PACKAGES_GET';
export const ALL_PACKAGES_GET_SUCCESS = 'ALL_PACKAGES_GET_SUCCESS';
export const ALL_PACKAGES_GET_ERROR = 'ALL_PACKAGES_GET_ERROR';

export const PACKAGE_DETAILS_ID = 'PACKAGE_DETAILS_ID';

export const CHECKUP_PAYMENTS = 'CHECKUP_PAYMENTS';
export const CHECKUP_PAYMENTS_SUCCESS = 'CHECKUP_PAYMENTS_SUCCESS';
export const CHECKUP_PAYMENTS_ERROR = 'CHECKUP_PAYMENTS_ERROR';

export const PROMTION_PACKAGES_GET = 'PROMTION_PACKAGES_GET';
export const PROMTION_PACKAGES_GET_SUCCESS = 'PROMTION_PACKAGES_GET_SUCCESS';
export const PROMTION_PACKAGES_GET_ERROR = 'PROMTION_PACKAGES_GET_ERROR';